import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="event-privacy"
//
// Place on an element that wraps BOTH the game type radios and the privacy
// checkboxes (e.g. the form). When the game type changes, the checkboxes are
// reset to that game's default settings.
//
// Values:
//   defaults       - { game_type: { show_bottles_before_event: bool, ... } },
//                    built server-side from Games::*.default_settings
//   applyOnConnect - apply the selected game's defaults on connect (new events
//                    only; never on edit, where saved settings must be kept)
export default class extends Controller {
  static targets = [
    "showBottlesBeforeEvent",
    "showRatingsDuringEvent",
    "showNotesDuringEvent",
    "showOtherReviewsDuringEvent"
  ]

  static values = {
    defaults: Object,
    applyOnConnect: Boolean
  }

  connect() {
    if (this.applyOnConnectValue) this.updateDefaults()
  }

  updateDefaults(event) {
    const gameTypeInput = event?.target ||
                          this.element.querySelector('input[name="event[game_type]"]:checked')
    if (!gameTypeInput) return

    const defaults = this.defaultsValue[gameTypeInput.value]
    if (!defaults) return

    const mapping = {
      showBottlesBeforeEvent: "show_bottles_before_event",
      showRatingsDuringEvent: "show_ratings_during_event",
      showNotesDuringEvent: "show_notes_during_event",
      showOtherReviewsDuringEvent: "show_other_reviews_during_event"
    }

    Object.entries(mapping).forEach(([target, key]) => {
      const hasTarget = this[`has${target.charAt(0).toUpperCase()}${target.slice(1)}Target`]
      if (hasTarget && key in defaults) {
        this[`${target}Target`].checked = Boolean(defaults[key])
      }
    })
  }
}
